import { RequireOnly } from '@pelicargo/types';
import { LineItemAudience, Markup } from '@prisma/client';

import { isSeparateLineItem } from './is-separate-line-item';

/**
 * Whether the customer sees this markup as its own row: its child line items are itemized for
 * the customer, or it's a separate line item, which everyone sees.
 */
export const isShownToCustomer = (markup: RequireOnly<Markup, 'child_itemized_for' | 'line_item_types'>) => {
  if (isSeparateLineItem(markup)) return true;

  return (markup.child_itemized_for ?? []).includes(LineItemAudience.CUSTOMER);
};
